import styled from 'styled-components';

const getBackgroundColor = (active, isPreviousCompleted, pending, theme) => {
  if (active || pending) {
    return theme.color.brandSecondary.medium;
  }
  if (isPreviousCompleted) {
    return theme.color.brandPrimary.light;
  }
  return '#e0e0e0';
};

export const Container = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  margin: "0 auto",
  padding: "10px 0",
}))


export const Step = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;

  &::after {
    content: '';
    position: absolute;
    top: 150%;
    left: 50%;
    transform: translateX(-50%);
    height: 4px;
    width: 100%;
    background-color: ${({ active, isPreviousCompleted }) => (active || isPreviousCompleted ? '#e65f1f' : '#e0e0e0')}; 
    z-index: 1;
  }
`;

export const StepNumber = styled.div(({ active, isPreviousCompleted, theme, pending }) => ({
  backgroundColor: getBackgroundColor(active, isPreviousCompleted, pending, theme),
  color: "white",
  borderRadius: "4px",
  width: "25px",
  height: "25px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "10px",
  padding: "4px",
}))


export const StepLabel = styled.div(({ theme }) => ({
  color: theme.color.neutral["02"],
}))

